var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33325 7.99992C2.33325 4.87525 4.87525 2.33325 7.99992 2.33325C11.1246 2.33325 13.6666 4.87525 13.6666 7.99992C13.6666 11.1246 11.1246 13.6666 7.99992 13.6666C4.87525 13.6666 2.33325 11.1246 2.33325 7.99992ZM1.33325 7.99992C1.33325 11.6759 4.32392 14.6666 7.99992 14.6666C11.6759 14.6666 14.6666 11.6759 14.6666 7.99992C14.6666 4.32392 11.6759 1.33325 7.99992 1.33325C4.32392 1.33325 1.33325 4.32392 1.33325 7.99992ZM10.0314 10.3915C10.1121 10.4389 10.2001 10.4615 10.2874 10.4615C10.4574 10.4615 10.6234 10.3742 10.7174 10.2175C10.8587 9.98018 10.7807 9.67352 10.5441 9.53152L8.27405 8.17818V5.23019C8.27405 4.95419 8.05072 4.73019 7.77405 4.73019C7.49805 4.73019 7.27405 4.95419 7.27405 5.23019V8.46218C7.27405 8.63819 7.36738 8.80152 7.51805 8.89219L10.0314 10.3915Z",
    fill: "#115099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.60f0ac6c.svg";
export { ForwardRef as ReactComponent };